import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Field names match actual API response
interface Teacher {
    teacher_id: string;
    teacher_name: string;
    teacher_email: string;
    ai_avatar: string | null;
    created_at: string;
}

interface TeacherAndEnrolledState {
    teacherList: Teacher[];
    next: string | null;
    previous: string | null;
    count: number | null;
    totalPages: number | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: TeacherAndEnrolledState = {
    teacherList: [],
    next: null,
    previous: null,
    count: 0,
    totalPages: 0,
    isLoading: false,
    error: null,
};

const getTeacherAndEnrolledSlice = createSlice({
    name: "getTeacherAndEnrolledSlice",
    initialState,
    reducers: {
        setTeacherAndEnrolledList: (
            state: TeacherAndEnrolledState,
            action: PayloadAction<Teacher[]>
        ) => {
            state.teacherList = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setPagination: (
            state: TeacherAndEnrolledState,
            action: PayloadAction<TeacherAndEnrolledState>
        ) => {
            state.next = action.payload.next;
            state.previous = action.payload.previous;
            state.count = action.payload.count;
            state.isLoading = false;
            state.error = null;
        },
        setLoading: (
            state: TeacherAndEnrolledState,
            action: PayloadAction<boolean>
        ) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        setError: (
            state: TeacherAndEnrolledState,
            action: PayloadAction<string>
        ) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetTeacherAndEnrolledList: () => {
            return initialState;
        },
    },
});

export const {
    setTeacherAndEnrolledList,
    setPagination,
    setLoading,
    setError,
    resetTeacherAndEnrolledList,
} = getTeacherAndEnrolledSlice.actions;

export default getTeacherAndEnrolledSlice.reducer;